<ion-content class="custom-select-popover">
  <!-- Barra de búsqueda -->
  <ion-searchbar
    placeholder="Buscar..."
    (ionInput)="onSearch($event)"
  ></ion-searchbar>

  <!-- Lista filtrada -->
  <ion-list>
    <ion-item
      button
      *ngIf="defaultValue"
      class="background-hover-grey"
      (click)="selectOption(defaultValue)"
    >
      {{ defaultValue.label }}
    </ion-item>

    <ion-item
      button
      class="background-hover-grey"
      *ngFor="let option of filteredOptions"
      (click)="selectOption(option)"
    >
      {{ option.label | translate }}
    </ion-item>

        <ion-item
      button
      *ngIf="filteredOptions.length === 0 && !defaultValue"
      class="background-hover-grey"
    >
      {{ 'error.no-data.list' | translate }}
    </ion-item>
  </ion-list>
</ion-content>
